import { Directive, HostBinding, Input } from '@angular/core'

import { Timeout } from '@app/core/model/enums/timeout.enum'

@Directive({ selector: '[ttlclass]' })
export class TTLClassDirective {
  @Input() ttlclass = ''
  @Input('ttlclass-expire') expire: number = Timeout.S
  @Input('ttlclass-cond')
  set show(newValue: boolean) {
    if (this.show != newValue) {
      this.className = this.ttlclass
      setTimeout(() => {
        this.className = ''
      }, this.expire)
    }
  }

  @HostBinding('class') className = ''
}
